import * as Utils from 'Assets/Utils'

import ClientHttpRequest from "Api/ClientHttpRequest"
import Immutable from 'immutable'
import { createModal } from 'Modules/Modal'
import {isLoading} from "Modules/Loading"

const initialState = Immutable.Map({})
	.set('modifyUser', new Immutable.Map({}))
	.set('setMailToken', new Immutable.Map({}))
	.set('getMailToken', new Immutable.Map({}))


/* Types */
export const SET_ACCOUNT_MODIFY = 'SET_ACCOUNT_MODIFY'
export const SET_MAIL_TOKEN = 'SET_MAIL_TOKEN'
export const GET_MAIL_TOKEN = 'GET_MAIL_TOKEN'

/* Reducer */
export default (state = initialState, action) => {

	switch (action.type) {
		case SET_ACCOUNT_MODIFY:
			return state.set('modifyUser', new Immutable.Map(action.Obj))
		case SET_MAIL_TOKEN:
			return state.set('setMailToken', new Immutable.Map(action.Obj))
		case GET_MAIL_TOKEN:
			return state.set('getMailToken', new Immutable.Map(action.Obj))
		default:
			return state;
	}
};

export const permissionFeature = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'auth/permissionFeature',
			method: "POST",
			data: {...form}
		}).request().then((response) => {
			dispatch(isLoading(false))
			return response.data.result
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const preRegistro = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'auth/newAccount',
			method: "POST",
			data: {...form}
		}).request().then(() => {
			dispatch(isLoading(false))
			return true
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const activateAccount = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'auth/activateAccount',
			method: "POST",
			data: {...form}
		}).request().then(() => {
			dispatch(isLoading(false))
			return true
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const setCorreoRegistro = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'auth/setCorreoRegistro',
			method: "POST",
			data: {...form}
		}).request().then((obj) => {
			dispatch(isLoading(false))
			dispatch({type: SET_MAIL_TOKEN, Obj: obj.data})
			return true
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const getValidateCorreoToken = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'auth/getValidateCorreoToken',
			method: "POST",
			data: {...form}
		}).request().then((obj) => {
			dispatch(isLoading(false))
			dispatch({type: GET_MAIL_TOKEN, Obj: obj.data})
			return true
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const sendRecoveryAccount = (form) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'auth/sendRecoveryAccount',
			method: "POST",
			data: {...form}
		}).request().then(() => {
			dispatch(isLoading(false))
			return true
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const resetPassword = (arrayReset) => {

	return (dispatch) => {

		dispatch(isLoading(true))

		return new ClientHttpRequest({
			service: 'api/resetPassword',
			method: "POST",
			data: { arrayReset },
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const changeUser = (data) => {
	let payloadReset = {
        actualizarUsuarios: {
          actualizarUsuario: [{
            createdBy: sessionStorage.uid,
            idDonataria: data.idDonataria,
            idUsuarioAnterior: data.idUsuario,
            usuarioNuevo: {
              idUsuario: data.form.direccionCorreo,
              nombre: data.form.nombre,
              apellidoPaterno: data.form.apellidoPaterno,
              apellidoMaterno: data.form.apellidoMaterno
            }
          }]
        }
	}

	return (dispatch) => {

		dispatch(isLoading(true))
		return new ClientHttpRequest({
			service: 'api/changeUser',
			method: "POST",
			data: payloadReset,
			headers: Object.assign({ "Authorization": sessionStorage.access_token, "uid": sessionStorage.uid })
		}).request().then(response => {
			dispatch(isLoading(false))
			return response
		}).catch(error => {
			dispatch(isLoading(false))
			dispatch(createModal(Utils.errorMessage(Utils.getMessageResponse(error.response.data))))
			throw error
		})
	}
}

export const setAccountModify = (obj) => {

	return (dispatch) => {
		dispatch({type: SET_ACCOUNT_MODIFY, Obj: obj})
		return Promise.resolve()
	}
}



// WEBPACK FOOTER //
// ./src/modules/PreRegister/index.js